import { useSelector } from 'react-redux';
import { useViewAsUser } from '../context/ViewAsContext';

const useEffectiveUser = () => {
    const { user: authUser } = useSelector((state) => state.authReducer.authData);
    const { rModalOpened, viewAsUser} = useSelector((state) => state.modalReducer);
    const contextViewAsUser = useViewAsUser()
    if (rModalOpened && (contextViewAsUser || viewAsUser)) {
        const effectiveViewAs = contextViewAsUser || viewAsUser;
        if (effectiveViewAs?._id && effectiveViewAs?.userType !== undefined) {
            return effectiveViewAs
        }
    }
    return authUser;
}

export default useEffectiveUser;